"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_beautiful_dnd_1 = require("react-beautiful-dnd");
exports.ConversionStepCanvasDraggable = ({ index, children }) => (react_1.default.createElement(react_beautiful_dnd_1.Draggable, { draggableId: `conversion-canvas-step-item-draggable-${index}`, index: index }, (draggableProvided, draggableSnapshot) => (react_1.default.createElement(react_1.default.Fragment, null,
    children(draggableProvided, draggableSnapshot),
    draggableProvided.placeholder))));
//# sourceMappingURL=Draggable.js.map